import { LoadCardsRequestAction, LoadCardsSuccessAction, LoadCardsErrorAction } from './actions.d';
import actionsTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload } from './types.d';

const actions = {
  loadCardsRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadCardsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_CARDS_REQUEST,
    payload,
  }),

  loadCardsSuccess: (payload: ILoadDataSuccessPayload): LoadCardsSuccessAction => ({
    type: actionsTypes.LOAD_CARDS_SUCCESS,
    payload,
  }),

  loadCardsError: (): LoadCardsErrorAction => ({
    type: actionsTypes.LOAD_CARDS_ERROR,
  }),
};

export default actions;
